import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { GeneralAlertEmailLog } from '@/contracts/AlertEmailLogs';
import { Pagination } from 'contracts/Pagination';

export interface PaginatedAlertEmailLogs {
  alertsEmailLog: GeneralAlertEmailLog[];
  pagination: Pagination;
}

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_ALERT_EMAIL_LOGS_',
  }
);

export interface PaginateAlertEmailLogsState {
  data: GeneralAlertEmailLog[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateAlertEmailLogsRequestAction {
  query?: any;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: GeneralAlertEmailLog[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateAlertEmailLogsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateAlertEmailLogsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateAlertEmailLogsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination},
  });

const failure = (state: PaginateAlertEmailLogsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateAlertEmailLogsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateAlertEmailLogs = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateAlertEmailLogsTypes = Types;
export const PaginateAlertEmailLogsActions = Creators;